import React, {lazy, Suspense} from "react";
import { makeStyles } from "@material-ui/core/styles";

import { useTitle } from "../../utils/pageTitles";

const SharedScratchGui = lazy(() => import("../../components/scratchIDE/sharedScratchGui"));
import Loader from "../../components/MainLoader";

import { connectTo } from "../../utils/generic";
import * as authActions from "../../actions/auth";
import * as ideActions from "../../actions/ide";
import * as notificationActions from '../../actions/notification';

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
}));

const SharedProject = ({
  ide,
  user,
  getProjectByRepository,
  clearCurrentProject,
  getRepository,
  showSuccessMessage,
  history,
  logout,
}) => {
  useTitle("blockjam");

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <Suspense fallback={<Loader></Loader>}>
          <SharedScratchGui
            user={user}
            ide={ide}
            getProjectByRepository={getProjectByRepository}
            clearCurrentProject={clearCurrentProject}
            getRepository={getRepository}
            showSuccessMessage={showSuccessMessage}
            history={history}
            logout={logout}
          />
        </Suspense>
      </div>
    </div>
  );
};

export default connectTo(
  (state) => {
    return {
      user: state.auth.user,
      ide: state.ide,
    };
  },
  {
    ...authActions, ...ideActions, ...notificationActions,
  },
  SharedProject
);
